import * as React from 'react';

import { BaseClipSelectPage } from 'blocks/ClipSelect';
import LoadingScreen from 'components/LoadingScreen';
import useAutomationSuggestedClipsPage from './useAutomationSuggestedClipsPage';

export interface AutomationSuggestedClipsPageContainerProps {
  children?: React.ReactElement;
}

const AutomationSuggestedClipsPageContainer: React.FC<AutomationSuggestedClipsPageContainerProps> = ({
  children,
}) => {
  const { isLoading } = useAutomationSuggestedClipsPage();

  return (
    <>
      <LoadingScreen message="" show={isLoading} fadeout />
      {
        // Don't want to mount children until loading is complete, but the
        // LoadingScreen component needs something to fill the page underneath
        // it so an empty <BaseClipSelectPage /> is used.
      }
      {!isLoading ? children : <BaseClipSelectPage />}
    </>
  );
};

export default AutomationSuggestedClipsPageContainer;
